import {
  LIST_MCU_PROJECT_REQUEST,
  LIST_MCU_PROJECT_SUCCESS,
  LIST_MCU_PROJECT_FAIL,
  LIST_MCU_PROJECT_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_REQUEST,
  CREATE_MCU_PROJECT_SUCCESS,
  CREATE_MCU_PROJECT_FAIL,
  DETAIL_MCU_PROJECT_REQUEST,
  DETAIL_MCU_PROJECT_SUCCESS,
  DETAIL_MCU_PROJECT_FAIL,
  DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_REQUEST,
  DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_SUCCESS,
  DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_FAIL,
  HISTORY_MCU_PROJECT_REQUEST,
  HISTORY_MCU_PROJECT_SUCCESS,
  HISTORY_MCU_PROJECT_FAIL,
  DETAIL_MCU_PROJECT_SETUP_REQUEST,
  DETAIL_MCU_PROJECT_SETUP_SUCCESS,
  DETAIL_MCU_PROJECT_SETUP_FAIL,
  UPDATE_MCU_PROJECT_REQUEST,
  UPDATE_MCU_PROJECT_SUCCESS,
  UPDATE_MCU_PROJECT_FAIL,
  UPDATE_MCU_PROJECT_SUTUP_REQUEST,
  UPDATE_MCU_PROJECT_SUTUP_SUCCESS,
  UPDATE_MCU_PROJECT_SUTUP_FAIL,
  DELETE_MCU_PROJECT_REQUEST,
  DELETE_MCU_PROJECT_SUCCESS,
  DELETE_MCU_PROJECT_FAIL,
  RESET_MCU_PROJECT,
  EXPORT_MCU_PROJECTS_REQUEST,
  EXPORT_MCU_PROJECTS_SUCCESS,
  EXPORT_MCU_PROJECTS_FAIL,
  DUPLICATE_MCU_PROJECTS_REQUEST,
  DUPLICATE_MCU_PROJECTS_SUCCESS,
  DUPLICATE_MCU_PROJECTS_FAIL,
  LIST_MCU_PACKAGE_SUMMARY_REQUEST,
  LIST_MCU_PACKAGE_SUMMARY_SUCCESS,
  LIST_MCU_PACKAGE_SUMMARY_FAIL,
  LIST_EXPORT_CLIENT_PROJECT_REQUEST,
  LIST_EXPORT_CLIENT_PROJECT_SUCCESS,
  LIST_EXPORT_CLIENT_PROJECT_FAIL,
  DOWNLOAD_EXPORT_CLIENT_PROJECT_REQUEST,
  DOWNLOAD_EXPORT_CLIENT_PROJECT_SUCCESS,
  DOWNLOAD_EXPORT_CLIENT_PROJECT_FAIL,
  DETAIL_MCU_RESULT_CATEGORY_REQUEST,
  DETAIL_MCU_RESULT_CATEGORY_SUCCESS,
  DETAIL_MCU_RESULT_CATEGORY_FAIL
} from '../../constants/mcu-projects'

const initialState = {
  loading: false,
  loadingPackageSummary:false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingHistory: false,
  loadingExport: false,
  mcuProjects: [],
  healthCare: {},
  historyLog: [],
  generalProjectSummary: [],
  mcuPackageSummary: [],
  mcuProject: {},
  mcuProjectSetup: {},
  productCode: '',
  productCodeClient: '',
  detailResultCategory: {},
  error: null,
  detailExportClient: [],
  loadingListDetail: false,
  exportDetail: {},
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXPORT_CLIENT_PROJECT_REQUEST:
      return { ...state, loadingListDetail: true, detailExportClient: [] }
    case LIST_EXPORT_CLIENT_PROJECT_SUCCESS:
      return {
        ...state,
        loadingListDetail: false,
        detailExportClient: action.payload,
        pageable: action.pageable
      }
    case LIST_EXPORT_CLIENT_PROJECT_FAIL:
      return {
        ...state,
        loadingListDetail: false,
        error: action.payload,
        detailExportClient: []
      }
    case DOWNLOAD_EXPORT_CLIENT_PROJECT_REQUEST:
      return { ...state, loadingExportDownload: true }
    case DOWNLOAD_EXPORT_CLIENT_PROJECT_SUCCESS:
      return {
        ...state,
        loadingExportDownload: false,
        exportDetail: action.payload,
        pageable: state.pageable
      }
    case DOWNLOAD_EXPORT_CLIENT_PROJECT_FAIL:
      return {
        ...state,
        loadingExportDownload: false,
        error: action.payload
      }
    case LIST_MCU_PROJECT_REQUEST:
      return { ...state, loading: true, mcuProjects: [] }
    case LIST_MCU_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjects: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjects: []
      }
    case LIST_MCU_PROJECT_SUMMARY_REQUEST:
      return { ...state, loading: true, generalProjectSummary: [] }
    case LIST_MCU_PROJECT_SUMMARY_SUCCESS:
      return { ...state, loading: false, generalProjectSummary: action.payload }
    case LIST_MCU_PROJECT_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload, generalProjectSummary: [] }
    case LIST_MCU_PACKAGE_SUMMARY_REQUEST:
      return { ...state, loadingPackageSummary: true, mcuPackageSummary: [] }
    case LIST_MCU_PACKAGE_SUMMARY_SUCCESS:
      return { ...state, loadingPackageSummary: false, mcuPackageSummary: action.payload }
    case LIST_MCU_PACKAGE_SUMMARY_FAIL:
      return { ...state, loadingPackageSummary: false, mcuPackageSummary: [], error: action.payload }
    case CREATE_MCU_PROJECT_REQUEST:
      return { ...state, loading: true }
    case CREATE_MCU_PROJECT_SUCCESS:
      return { ...state, loading: false }
    case CREATE_MCU_PROJECT_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_MCU_PROJECT_REQUEST:
      return { ...state, loadingDetail: true, mcuProject: {} }
    case DETAIL_MCU_PROJECT_SUCCESS:
      return { ...state, loadingDetail: false, mcuProject: action.payload }
    case DETAIL_MCU_PROJECT_FAIL:
      return { ...state, loadingDetail: false, mcuProject: {}, error: action.payload }
    case DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_REQUEST:
      return { ...state, loadingDetail: true, healthCare: {} }
    case DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_SUCCESS:
      return { ...state, loadingDetail: false, healthCare: action.payload }
    case DETAIL_HEALTHCARE_SUPPORT_MCU_PROJECT_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        healthCare: {}
      }
    case HISTORY_MCU_PROJECT_REQUEST:
      return { ...state, loadingHistory: true, historyLog: [] }
    case HISTORY_MCU_PROJECT_SUCCESS:
      return { ...state, loadingHistory: false, historyLog: action.payload }
    case HISTORY_MCU_PROJECT_FAIL:
      return { ...state, loadingHistory: false, historyLog: [], error: action.payload }
    case DETAIL_MCU_PROJECT_SETUP_REQUEST:
      return { ...state, loadingDetail: true, mcuProjectSetup: {} }
    case DETAIL_MCU_PROJECT_SETUP_SUCCESS:
      return { ...state, loadingDetail: false, mcuProjectSetup: action.payload }
    case DETAIL_MCU_PROJECT_SETUP_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        mcuProjectSetup: {}
      }
    case UPDATE_MCU_PROJECT_SUTUP_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_MCU_PROJECT_SUTUP_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_MCU_PROJECT_SUTUP_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case UPDATE_MCU_PROJECT_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_MCU_PROJECT_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_MCU_PROJECT_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_MCU_PROJECT_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_MCU_PROJECT_SUCCESS:
      const mcuProjectId = action.payload
      const indexServiceCategory = state.mcuProjects.findIndex(
        (mcuProject) => mcuProject.id === mcuProjectId
      )
      state.mcuProjects.splice(indexServiceCategory, 1)

      return { ...state, loadingDelete: false }
    case DELETE_MCU_PROJECT_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_MCU_PROJECT:
      return { ...state, loading: false, error: null }

    case EXPORT_MCU_PROJECTS_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_MCU_PROJECTS_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_MCU_PROJECTS_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    case DUPLICATE_MCU_PROJECTS_REQUEST:
      return { ...state, loadingUpdate: true }
    case DUPLICATE_MCU_PROJECTS_SUCCESS:
      return { ...state, loadingUpdate: false }
    case DUPLICATE_MCU_PROJECTS_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case 'SET_PRODUCT_CODE':
      return { ...state, productCode: action.payload }
    case 'SET_PRODUCT_CODE_CLIENT':
    return { ...state, productCodeClient: action.payload }
    case DETAIL_MCU_RESULT_CATEGORY_REQUEST:
      return { ...state, loadingDetail: true, detailResultCategory: {} }
    case DETAIL_MCU_RESULT_CATEGORY_SUCCESS:
      return { ...state, loadingDetail: false, detailResultCategory: action.payload }
    case DETAIL_MCU_RESULT_CATEGORY_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        detailResultCategory: {}
      }
    case "DETAIL_MCU_WORK_FITNESS_REQUEST":
      return { ...state, loadingDetail: true, detailWorkFitness: {} }
    case "DETAIL_MCU_WORK_FITNESS_SUCCESS":
      return { ...state, loadingDetail: false, detailWorkFitness: action.payload }
    case "DETAIL_MCU_WORK_FITNESS_FAIL":
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        detailWorkFitness: {}
      }
    default:
      return state
  }
}

export default mcuProjectReducer
